import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { DealPreviewStyled } from '../DealPreviewStyled';
import { rem } from 'polished';

export const DealPreviewStyledAP = styled(DealPreviewStyled)`
    .step-container {
        .icon {
            &.ok {
                background: ${({ theme }) => theme.colors.primary};
                border: 3px solid ${({ theme }) => theme.colors.primary};
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }
        }
        .text {
            &.ok {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }
        }
    }

    .deal {
        .deal-content {
            .car-header {
                .price-and-date {
                    padding-right: 10px;

                    .date {
                        font-size: ${({ theme }) => theme.fontSizes.textBase};
                        padding-right: 0;

                        .date-clock-icon {
                            margin-right: ${rem(9)};
                        }
                        span {
                            .text {
                                color: ${({ theme }) => theme.colors.grey2};
                            }
                            .date {
                                font-size: ${({ theme }) => theme.fontSizes.textBase};
                                color: ${({ theme }) => theme.colors.primaryBlack};
                            }
                        }
                    }
                }
                .price-container {
                    .price {
                        span {
                            font-weight: ${({ theme }) => theme.fontWeights.textBold};
                        }

                        .currencyLabel,
                        .monthly-price-suffix {
                            font-size: ${({ theme }) => theme.fontSizes.textSupBase} !important;
                        }
                    }
                }

                .car-title {
                    text-transform: uppercase;
                    font-size: ${rem(20)};
                    line-height: ${rem(20)};
                    padding-bottom: ${rem(7)};
                }

                .title-engineInfo {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                }
            }
        }
        .buttons {
            .buttons-box {
                padding: ${rem(20)} ${rem(30)};

                .remove-deal {
                    font-weight: normal;
                    @media (min-width: ${breakpoints.sm}px) {
                        display: none;
                    }
                }
            }

            .buttons-box-right {
                @media (min-width: ${breakpoints.sm}px) {
                    display: flex;
                    flex-direction: column;
                }

                .continue__large.continue {
                    background-color: ${({ theme }) => theme.colors.blue4};
                    color: ${({ theme }) => theme.colors.white};
                }

                .continue__large {
                    @media (min-width: ${breakpoints.sm}px) {
                        width: ${rem(290)};
                        height: ${rem(50)};
                    }
                }
                .remove-deal--under-btn {
                    padding: ${rem(5)} ${rem(5)} ${rem(25)} ${rem(54)};
                    color: ${({ theme }) => theme.colors.blue4};
                    font-size: ${rem(16)};
                    text-transform: lowercase;
                    text-decoration: none;

                    @media (max-width: ${breakpoints.xs}px) {
                        display: none;
                    }

                    ::first-letter {
                        text-transform: uppercase;
                    }
                }
            }
        }
    }

    .deal .deal-content__order-data {
        padding: ${rem(20)};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        margin: 0;
        @media (min-width: ${breakpoints.sm}px) {
            padding: ${rem(30)} ${rem(30)} ${rem(10)};
        }
    }

    .deal .deal-steps-flow .timeline {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
    }

    .deal .deal-content .buttons .view-all-details {
        border: 1px solid ${({ theme }) => theme.colors.primaryBlack};
        font-size: ${rem(10)};
        padding: ${rem(16)} ${rem(20)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        width: auto;

        &:focus-visible,
        &:hover {
            color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    .deal .deal-content .buttons .remove-deal {
        display: block;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        color: ${({ theme }) => theme.colors.primary};
        width: auto;
        text-decoration: none;
        text-transform: unset;
    }

    .deal .deal-content .buttons button.continue {
        width: auto;
        font-size: ${rem(10)};
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.white};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        margin: 0;
        &:focus-visible,
        &:hover {
            background: ${({ theme }) => theme.colors.primaryBlack};
            border-color: ${({ theme }) => theme.colors.primaryBlack};
        }
    }

    .deal .deal-steps-flow .timeline {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
    }

    .deal .deal-content .buttons .view-all-details {
        border: 1px solid ${({ theme }) => theme.colors.primaryBlack};
        font-size: ${rem(10)};
        text-decoration: none;
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        width: auto;

        &:focus-visible,
        &:hover {
            color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    .deal .deal-content .buttons .remove-deal {
        display: block;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        color: ${({ theme }) => theme.colors.primary};
        width: auto;
        text-decoration: none;
        text-transform: unset;
    }

    .deal .deal-content .buttons button.continue {
        width: auto;
        font-size: ${rem(10)};
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.white};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        &:focus-visible,
        &:hover {
            background: ${({ theme }) => theme.colors.primaryBlack};
            border-color: ${({ theme }) => theme.colors.primaryBlack};
        }
    }

    .deal .deal-content .buttons .continue__large {
        display: block !important;
    }
`;
